import React from 'react';
import PropTypes from 'prop-types';
import { defineMessages, useIntl } from 'react-intl';
import { classNameWithModifiers as withMods } from 'helpers/class-name';
import Message from 'components/Message';
import { SvgArrow } from 'components/Svgs';

import './PageTurner.scss';

const messages = defineMessages({
  xThroughy: {
    id: 'page-turner.x-through-y',
    defaultMessage: '{startNumber, number} - {endNumber, number}',
  },
  xThroughyOfz: {
    id: 'page-turner.x-through-y-of-z',
    defaultMessage: '{startNumber, number} - {endNumber, number} of {count, number}',
  },
  nextPage: {
    id: 'page-turner.next-page',
    defaultMessage: 'Next page',
  },
  previousPage: {
    id: 'page-turner.previous-page',
    defaultMessage: 'Previous page',
  },
});

const PageTurner = ({
  children,
  className,
  rightSideContent,

  count,
  endNumber,
  isLoading,
  message,
  viewNextPage,
  viewPrevPage,
  isOnFirstPage,
  isOnLastPage,
  startNumber,
}) => {
  const intl = useIntl();

  if (count === 0) return null;

  const rangeMessage = message ?? (count != null ? messages.xThroughyOfz : messages.xThroughy);
  const rangeValues = count != null ? { startNumber, endNumber, count } : { startNumber, endNumber };
  const showRangeText = !isLoading && !(startNumber === 0 && endNumber === 0);

  return (
    <div className={withMods('page-turner', className)}>
      <div className="page-turner__item-group">{children}</div>
      <div className="page-turner__item-group">
        {rightSideContent}
        <div className="page-turner__controls">
          {showRangeText && (
            <Message className="text--sm page-turner__text" message={rangeMessage} values={rangeValues} />
          )}
          <button
            type="button"
            className="page-turner__button"
            aria-label={intl.formatMessage(messages.previousPage)}
            disabled={isOnFirstPage}
            onClick={viewPrevPage}>
            <SvgArrow theme={isOnFirstPage ? 'disabled' : 'brand'} direction="left" />
          </button>
          <button
            type="button"
            className="page-turner__button"
            aria-label={intl.formatMessage(messages.nextPage)}
            disabled={isOnLastPage}
            onClick={viewNextPage}>
            <SvgArrow theme={isOnLastPage ? 'disabled' : 'brand'} direction="right" />
          </button>
        </div>
      </div>
    </div>
  );
};

PageTurner.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  rightSideContent: PropTypes.node,
  count: PropTypes.number,
  endNumber: PropTypes.number,
  isLoading: PropTypes.bool,
  message: PropTypes.shape({
    id: PropTypes.string.isRequired,
    defaultMessage: PropTypes.string.isRequired,
  }),
  viewNextPage: PropTypes.func,
  viewPrevPage: PropTypes.func,
  isOnFirstPage: PropTypes.bool,
  isOnLastPage: PropTypes.bool,
  startNumber: PropTypes.number,
};

export default PageTurner;
